<template>
  <div :class="['nt-theme', getTheme]">
    <div v-if="isMobile">
      <nt-select2
        :id="id"
        ref="select"
        :label="label"
        :theme="theme"
        :placeholder="placeholder"
        :validators="validators"
        :data-source="dataSource"
      />
    </div>
    <div
      v-if="!isMobile"
      :class="{ 'decorated' : decorated }"
    >
      <label>{{ label }}</label>
      <div
        :id="id"
        class="nt-radiogroup"
        role="radiogroup"
        :class="{ 'nt-radiogroup--decorated' : decorated }"
      >
        <nt-radio
          v-for="(item, i) in dataSource"
          :id="id + '-radio-' + i"
          :key="item.id"
          :item="item"
          :theme="theme"
        />
      </div>
      <div
        v-if="error"
        class="nt-form-error"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import emitter from 'tiny-emitter/instance'
import NtRadio from './nt-form-radio.vue'
import NtSelect2 from '../nt-form-select-2/nt-form-select-2.vue'

export default {
  name: 'nt-radiogroup',
  components: {
    NtRadio,
    NtSelect2
  },
  props: {
    id: {
      type: String,
      default: 'radiogroup'
    },
    theme: {
      type: String,
      default: 'default'
    },
    label: {
      type: String,
      default: null
    },
    dataSource: {
      type: Array,
      default: []
    },
    placeholder: {
      type: String,
      default: null
    },
    validators: {
      type: Array,
      default: []
    },
    decorated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      error: null,
      width: 0
    }
  },
  computed: {
    ...mapState('formStore', ['errors']),
    getTheme() {
      return `nt-theme--${this.theme}`
    },
    isMobile() {
      return this.width <= 766
    }
  },
  watch: {
    errors: {
      handler(values) {
        const [error] = _.values(_.find(values, this.id, _.first))
        this.error = error

        if (this.$refs.select) {
          this.$refs.select.error = this.error
        }
      },
      deep: true
    }
  },
  created() {
    // Add to form initial values
    this.changeForm()
    // Add validators to form
    this.changeValidators({
      [this.id]: this.validators
    })
    emitter.on('onSelectFormRadio', this.onSelect)
    // emitter.on('changeForm', this.onSelect)
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    ...mapActions('formStore', ['changeFormData', 'changeValidators']),
    onSelect(val) {
      if (typeof val === 'object') {
        this.selected = val[this.id] !== this.selected ? val[this.id] : null
      } else {
        this.selected = val !== this.selected ? val : null
      }
      emitter.emit('selectRadio', this.selected)
      this.changeForm()

      if (this.$refs.select) {
        this.$refs.select.data.forEach(element => {
          if (element.Value === val) {
            this.$refs.select.selected = element
          }
        })
      }
    },
    changeForm() {
      emitter.emit('changeForm', {
        [this.id]: this.selected
      })
    },
    onResize() {
      this.width = window.innerWidth
    }
  }
}
</script>

<style lang="scss" scoped>
  .nt-radiogroup {
    $container: &;
    display: flex;
    flex-wrap: wrap;

    & .radio:not(:last-child) {
      margin-right: 1.25rem;
    }

    &--decorated {
      justify-content: center;
      text-align: center;

      & .radio {
        padding: 0.625rem 1.875rem 0.625rem 1.875rem;

        &:not(:last-child) {
          margin-right: 0;
        }
      }
    }
  }
  .decorated {
    & .nt-form-error {
      text-align: center;
    }
  }
</style>
